import {
  IconButton,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
} from "@mui/material";
import { useApp } from "context";
import { Enums, Helpers, Store } from "utils";
import { IBroadcast } from "interfaces";
import DeleteIcon from "@mui/icons-material/Delete";
import DraftsIcon from "@mui/icons-material/Drafts";
import MarkunreadIcon from "@mui/icons-material/Markunread";

type Props = {
  action?: boolean;
  item: IBroadcast;
  onAction: (value: IBroadcast) => void;
};

export const Broadcast = (props: Props) => {
  const { locale, t, theme } = useApp();

  const isClinic = Store.sessionStorage.isClinic();

  function handleAction() {
    props.onAction && props.onAction(props.item);
  }

  return (
    <>
      <ListItem disableGutters disablePadding dense>
        <ListItemText
          primary={
            <Typography
              sx={{
                fontSize: theme.font.md,
                color: theme.palette.font.color,
              }}
            >
              {props.item.content}
            </Typography>
          }
          secondary={
            <Typography
              sx={{
                fontSize: theme.font.sm,
                color: theme.palette.font.accent,
              }}
            >
              {Helpers.interpolate(t.message.broadcast.received_at, {
                date: Helpers.toRelativeDate(
                  props.item.broadcastTime,
                  t.relative_date,
                  locale,
                  true
                ),
              })}
            </Typography>
          }
        />
        {isClinic || props.action ? (
          <ListItemSecondaryAction>
            {!isClinic &&
            props.item.broadcastType === Enums.EnumBroadcastType.Reminder ? (
              props.item.received ? (
                <IconButton sx={{ color: theme.palette.font.color }}>
                  <DraftsIcon />
                </IconButton>
              ) : (
                <IconButton
                  sx={{ color: theme.palette.font.color }}
                  onClick={handleAction}
                >
                  <MarkunreadIcon />
                </IconButton>
              )
            ) : isClinic ||
              props.item.broadcastType ===
                Enums.EnumBroadcastType.Announcement ? (
              <IconButton
                sx={{ color: theme.palette.font.color }}
                onClick={handleAction}
              >
                <DeleteIcon />
              </IconButton>
            ) : null}
          </ListItemSecondaryAction>
        ) : null}
      </ListItem>
    </>
  );
};
